import { ref } from "vue";
import { getGlobalProperties } from "@/assets/js/utils.js";
import SwipeComponent from "../../home/tabs/common/SwipeComponent.vue";
import VideoItem from "../../home/tabs/common/VideoItem.vue";
import { useStore } from "vuex";
export default {
  components: {
    SwipeComponent,
    VideoItem
  },

  setup(props) {
    let page = ref(1);
    let showDetailsPopul = ref(false);
    let menu_id = ref("");
    let menuTetx = ref("");
    const finished = ref(false);
    let videoList = ref([]);
    const error = ref(false);
    const loading = ref(false);
    const store = useStore();
    let showLoding = ref(true);
    const isMore = ref(false);
    const {
      concentrationApi,
      videoMoreApi
    } = getGlobalProperties().$api;
    videoList.value = localStorage.getItem("FeaturedComponent") ? JSON.parse(localStorage.getItem("FeaturedComponent")) : [];

    const getVideoList = () => {
      concentrationApi({}, "get").then(res => {
        showLoding.value = false;
        videoList.value = [];

        if (res.code === 0) {
          if (res.data.length) {
            localStorage.setItem("FeaturedComponent", JSON.stringify([res.data[0]]));
          }

          videoList.value = res.data;
          loading.value = false; // if (res.data.length === 0) {

          finished.value = true; // }
        }
      });
    };

    getVideoList();

    const onLoad = () => {// loading.value = true;
      // page.value++;
      // getVideoList();
    };

    const menuAll = item => {
      menu_id.value = item.category_id;
      menuTetx.value = item.name;
      showDetailsPopul.value = true;
    };

    const videoPlay = item => {
      store.commit("SET_LOGIN_POPUP", {
        show: true,
        type: "VideoDetails"
      });
      store.commit("SET_VIDEO_DETAILS", item);
    };

    const close = () => {
      showDetailsPopul.value = false;
      menuTetx.value = "";
    };

    const videoMore = item => {
      isMore.value = true;
      videoMoreApi({
        category_id: item.category_id
      }, "get").then(res => {
        if (res.code === 0 && res.data && res.data.length) {
          isMore.value = false;
          videoList.value.some(elem => {
            if (elem.category_id === item.category_id) {
              elem.rows = res.data;
              return true;
            }
          });
        }
      });
    };

    return {
      props,
      videoList,
      loading,
      onLoad,
      error,
      videoPlay,
      finished,
      showLoding,
      showDetailsPopul,
      menu_id,
      menuAll,
      menuTetx,
      close,
      videoMore,
      isMore
    };
  }

};